import { Link } from "react-router-dom"
import { DisplayValue } from "../../.."
import { observer } from 'mobx-react-lite'
import { store } from '../../../stores/Store'
import { Icons, TypeIcon } from "../../../misc/Icons"
import { format } from "date-fns"
import NodeMenus from "../../../misc/NodeMenus"
import { Theme } from "../../../misc/Theme"
import { UTCDate } from "@date-fns/utc"


export default observer(function FolderPanelListItem ({node}: any) {    

    const { folderNode, leafNode, getDisplayType } = store.NodeStore
    
    const displayName = node.label ? node.label : node.uid
    const isLeafNode = [
        "Aora.Nationality.Data.SponsorNode",
        "Aora.Nationality.Data.PersonNode",
        "Aora.Nationality.Data.JobNode",
        "Aora.Platform.Data.EnquiryNode",
        "Aora.Platform.Data.AutomationNode",
        "Aora.Platform.Data.UserNode"
    ].indexOf(node.typeName) > -1
    
    const displayType = getDisplayType(node)
    const link = !isLeafNode
        ? `/app/main/${node.uid}`
        : `/app/main/${folderNode.uid}/${node.uid}`

    const isStateSubject: boolean = store.AppStore.stateSubject === node.uid
    const selected = node.uid === leafNode?.uid || (!leafNode && node.uid === folderNode?.uid)
    var classes = "panel-list-item"
    classes = isStateSubject ? `${classes} state-subject` : classes
    classes = selected ? `${classes} selected` : classes

    return (
        <div className={classes}>
            <Link to={link} aria-label={`${displayType}: ${displayName}`}>
                <TypeIcon node={node} />
                
                <ListItemLabel node={node} />

                <ListItemStatus node={node} />
            </Link>

            {!isLeafNode ? <NodeMenus node={node} /> : null}
        </div>
    )
})


const ListItemStatus = observer(({node}: any) => {

    var isStateSubject: boolean = store.AppStore.stateSubject === node.uid    

    if (isStateSubject) {
        return <div className="status-indicator" style={{marginLeft: "auto"}}>{store.AppStore.stateAction}</div>
    }

    if (node.typeName === "Aora.Platform.Data.EnquiryNode") {
        return (
            <div 
                className="status-indicator" 
                style={{marginLeft: "auto", color: store.EnquiryStore.color(node)}}>
                {DisplayValue("enquiry_status", node.status)}
            </div>
        )
    }

    if (node.typeName === "Aora.Platform.Data.AutomationNode") {
        if (node.uid === store.AutomationStore.runningAutomation?.parentUid) {
            return (
                <div className="status-indicator" style={{marginLeft: "auto", color: Theme.palette.info.contrastText}}>
                    Running
                </div>
            )
        }
    }
    
    return <></>
})


function ListItemLabel ({node}: any) {

    switch (node.typeName) {
        
        case "Aora.Platform.Data.EnquiryNode":
            
            return (
                <div style={{display: "grid", paddingRight: "8px"}}>
                    <span className="trunc-ellipsis" style={{fontSize: "13px"}}>{store.NodeStore.getDisplayName(node)}</span>
                    <span className="trunc-ellipsis" style={{width: "auto", fontSize: "10px", color: "grey"}}>{store.EnquiryStore.getSubject(node)?.name}</span>
                </div>
            )

        case "Aora.Nationality.Data.PersonNode":

            var dob = new UTCDate(node.dateOfBirth)
            var dob_str = dob > new UTCDate("1000-01-01") ? format(dob, "yyyy-MM-dd") : ""

            return (
                <div style={{display: "grid", paddingRight: "8px"}}>
                    <span className="trunc-ellipsis" style={{fontSize: "13px"}}>{store.NodeStore.getDisplayName(node)}</span>
                    <span className="trunc-ellipsis" style={{width: "auto", fontSize: "10px", color: "grey"}}>{dob_str} <Icons.Dot style={{fontSize: "7px"}} /> {node.countryOfBirth}</span>
                </div>
            )
        
        case "Aora.Platform.Data.AutomationNode":
            
            return (
                <div style={{display: "grid", paddingRight: "8px"}}>
                    <span className="trunc-ellipsis" style={{fontSize: "13px"}}>{store.NodeStore.getDisplayName(node)}</span>
                    <span className="trunc-ellipsis" style={{width: "auto", fontSize: "10px", color: "grey"}}>
                        {node.enquiry ? node.enquiry.uid.replace("ENQUIRY_", "Enquiry ") : "Standalone"}
                    </span>
                </div>
            )
        
        case "Aora.Nationality.Data.SponsorNode":

            return (
                <span className="trunc-ellipsis">Sponsor info</span>
            )
        
        case "Aora.Nationality.Data.JobNode":
            
            return (
                <div style={{display: "grid", paddingRight: "8px"}}>
                    <span className="trunc-ellipsis" style={{fontSize: "13px"}}>{store.NodeStore.getDisplayName(node)}</span>
                    <span className="trunc-ellipsis" style={{width: "auto", fontSize: "10px", color: "grey"}}>
                        {node.occupationCode ? node.occupationCode : "No occupation code chosen"}
                    </span>
                </div>
            )

        default:
            
            var label = store.NodeStore.getDisplayName(node)
            label = node.role ? `${label} ${node.role.join(", ")}` : label

            return (
                <span className="trunc-ellipsis">{label}</span>
            )
    }
}